import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { UPLOAD_ICON_ALT } from "../utils/svgs_new";
import { AppIcon } from "./Generic/AppIcon";

interface Props {
  isSelfie?: boolean;
  onClick: () => void;
}

const UploadPlaceholder = (props: Props) => {
  return (
    <UploadPlaceholder.Styled onClick={props.onClick}>
      <AppIcon icon={UPLOAD_ICON_ALT} size={16} />
      <span>
        {translate(
          props.isSelfie === true ? STRINGS.CLICK_TO_TAKE_A_SELFIE : STRINGS.UPLOAD_DOCUMENT
        )}
      </span>
    </UploadPlaceholder.Styled>
  );
};

UploadPlaceholder.Styled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  color: var(--gray-600);
  font-weight: 600;
  font-size: 14px;
  border: 1px dashed var(--gray-200);
  border-radius: 8px;
  padding: 24px;
`;

export default UploadPlaceholder;
